import { TextBox, TextBoxProps } from "../core/components/textBox.js";
import { DropDownList, DropDownListProps } from "../core/components/dropDownList.js";
import { Button } from "../core/components/button.js";
import { ComponentHelper } from "../core/util/componentHelper.js";
import { ToggleButtonGroup } from "../core/components/toggleButtonGroup.js";
import { Helper } from "../core/util/helper.js";
import { KeyValuePair } from "../commonInterfaces.js";
import React from "react";
export type SearchType = "projNr" | "ressNr" | "resource" | "adrName" | "plz" | "barText";

export class GraphicFocussingFilter extends React.Component<GraphicFocussingFilterProps, GraphicFocussingFilterState> {
    private factory = ComponentHelper.createFactory();
    private dataSource: KeyValuePair<string, string>[];
    private dropDownProps: DropDownListProps;
    private textBoxProps: TextBoxProps;

    private TEXT_BOX_VALUE = "graphicFocussingFilter_textBoxValue";
    private DROP_BOX_VALUE = "graphicFocussingFilter_dropBoxValue";


    constructor(props: GraphicFocussingFilterProps) {
        super(props)
        this.state = {
            textBoxValue: Helper.loadDataFromStorage(this.TEXT_BOX_VALUE) || "",
            dropDownValue: Helper.loadDataFromStorage(this.DROP_BOX_VALUE) || "projNr"
        }
        this.initApp().then();

    }

    private initApp = async () => {

        this.textBoxProps = this.factory.getDefaultTextBoxProps();
        this.textBoxProps.field.triggerOnChange = true;
        this.textBoxProps.onChange = this.onTextBoxChange;
        this.dropDownProps = this.factory.getDefaultDropDownProps();

        this.dropDownProps.field.dataTextField = "Value";
        this.dropDownProps.field.dataValueField = "Key";
        this.dropDownProps.onChange = this.onDropBoxChange;
        this.dropDownProps.onDataLoaded = null;
        this.dropDownProps.field.optionLabel = "";
        this.dropDownProps.field.refreshDSOnRefChange = true;
        this.setDataSource();
        setTimeout(() => {
            this.setState({})
        }, 0)
    }

    private setDataSource = () => {
        this.dataSource = [
            {
                Key: "projNr",
                Value: Helper.getTranslation("Field.Einsatz.projnr")
            }, {
                Key: "ressNr",
                Value: Helper.getTranslation("WebSMS.ResourcePlaningGrouping.GridRessNr")
            }, {
                Key: "resource",
                Value: Helper.getTranslation("Field.Ressource.ResourceName")
            }, {
                Key: "adrName",
                Value: Helper.getTranslation("Adresse.Adresse")
            }, {
                Key: "plz",
                Value: Helper.getTranslation("Field.Adresse.plz")
            }, {
                Key: "barText",
                Value: Helper.getTranslation("WebSMS.ResourcePlaningGrouping.GridGruppeName.BarText")
            }
        ].filter((item) => {
            const isResourceItem = item.Key == "ressNr" || item.Key == "resource";
            return !(!this.props.groupedByResource && isResourceItem);

        }).sort((a, b) => {
            if (a.Value < b.Value) {
                return -1;
            } else if (b.Value > a.Value) {
                return 1;
            }
            return 0;
        });

        this.dropDownProps.dataSource = this.dataSource;
    }

    private onDropBoxChange = (_: any, value: any) => {
        this.setState({ dropDownValue: value }, () => {
            Helper.saveDataToStorage(this.DROP_BOX_VALUE, value, false);
            this.props.onValueChange(value, this.state.textBoxValue)
        })
    }

    private onTextBoxChange = (_: any, value: any) => {
        this.setState({ textBoxValue: value }, () => {
            Helper.saveDataToStorage(this.TEXT_BOX_VALUE, value, false);
            this.props.onValueChange(this.state.dropDownValue, value)
        })
    }

    private handleClickForward = () => {
        if (!Helper.isNullOrEmpty(this.state.textBoxValue)) {
            this.props.onNavigateForward(this.state.dropDownValue, this.state.textBoxValue);
        }
    }

    private handleClickBackward = () => {
        if (!Helper.isNullOrEmpty(this.state.textBoxValue)) {
            this.props.onNavigateBackward(this.state.dropDownValue, this.state.textBoxValue);
        }
    }

    componentDidMount() {
        this.props.onValueChange(this.state.dropDownValue, this.state.textBoxValue)
    }

    componentDidUpdate(prevProps: GraphicFocussingFilterProps) {
        if (prevProps.groupedByResource != this.props.groupedByResource) {
            this.setDataSource();
            this.setState({});
        }
    }

    render() {
        if (Helper.hasValue(this.dataSource)) {
            return (
                <>
                    <ToggleButtonGroup style={{ margin: "0 10px 10px 0", display: "flex", alignItems: "center" }}>
                        <div style={{ width: "145px", marginRight: "5px" }}>
                            <DropDownList {...this.dropDownProps} value={this.state.dropDownValue} />
                        </div>
                        <div className="graphic-focusing-manager" style={{ width: "145px", margin: "0 0 0 5px", borderRadius: "var(--border-radius)" }}>
                            <div className="graphic-focusing-manager_textbox">
                                <TextBox {...this.textBoxProps} value={this.state.textBoxValue} />
                            </div>
                            <Button handleClick={this.handleClickBackward} iconName={"arrow-left"} readOnly={Helper.isNullOrEmpty(this.state.textBoxValue)} buttonStyle={{ borderLeft: "none", borderColor: "#ced4da", backgroundColor: "#e4e7eb", width: "30px" }} />
                            <Button handleClick={this.handleClickForward} iconName={"arrow-right"} readOnly={Helper.isNullOrEmpty(this.state.textBoxValue)} buttonStyle={{ borderRadius: "var(--rounded-right)", borderColor: "#ced4da", backgroundColor: "#e4e7eb", width: "30px" }} />
                        </div>
                    </ToggleButtonGroup>
                </>
            );
        } else {
            return null;
        }
    }
}

interface GraphicFocussingFilterProps {
    onNavigateForward: (searchType: SearchType, value: string) => void;
    onNavigateBackward: (searchType: SearchType, value: string) => void;
    onValueChange: (searchType: SearchType, value: string) => void;
    groupedByResource: boolean;
}

interface GraphicFocussingFilterState {
    textBoxValue: string;
    dropDownValue: SearchType;
}